import { loadFullPage } from "./loadFullPage";
import { postFetch } from "./postFetch";
import { toastErroCarregar } from "./toastErroCarregar";
import i18next from "i18next";
import { inicializarInternacionalizacao } from "../localizacao/buscaCnpj/buscaCnpj";

const onlyAlphaNum = (s) => (s || '').replace(/[^A-Za-z0-9]/g, '');
const isCnpjLike = (cnpj) => /^[A-Za-z0-9]{14}$/.test(onlyAlphaNum(cnpj));
const cnpjEndpoint = `/${CULTURE_EMPREGARE}/HotSiteEmpresa/BuscarDadosCnpjPreencherForm`;

export async function buscaCnpj(cnpj, form) {
  inicializarInternacionalizacao();
  const _q = (name) => form?.querySelector(`#${name}`);
  
  const _set = (name, val, triggerChange = false) => {
    const el = _q(name);
    if (el) el.value = val ?? '';

    if (triggerChange) {
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
        el.dispatchEvent(new Event('countrychange', { bubbles: true }));
    }
  };

  const _setSelect = (name, val, triggerChange = false) => {
    const el = _q(name);
    if (el && el.tagName === 'SELECT') el.value = val ?? '';

    if (triggerChange) {
        el.dispatchEvent(new Event('select', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
    }
};

function setCidadeQuandoCarregar(form, cidadeId) {
  
  const handler = () => {
    document.removeEventListener('OpcoesCidadesCarregadasEvent', handler);

    const el = form?.querySelector('#cidadeID');
    const ts = el?.tomselect;

    const id = cidadeId != null ? String(cidadeId) : '';
    if (!ts || !id) return;

    if (ts.options[id]) {
      ts.setValue(id, false);
    }
  };

  document.addEventListener('OpcoesCidadesCarregadasEvent', handler);

  // força o load agora (sem precisar esperar o foco/click do usuário)
  const ts = form?.querySelector('#cidadeID')?.tomselect;
  if (ts) {
    ts.clearOptions();
    ts.load('', () => ts.refreshOptions(false));
  }
}

  const _preencher = (dados) => {
    _set('Razao', dados?.NomeEmpresarial);
    _set('Nome', dados?.NomeFantasia);

    const end = dados?.DadosEndereco ?? dados?.Endereco ?? {};

    _set('Logradouro', end?.Logradouro);
    _set('Numero', end?.Numero);
    _set('Bairro', end?.Bairro);
    _set('Complemento', end?.Complemento);

    const cep = end?.Cep;
    const cepLimpo = (cep || '').replace(/\D+/g, '');
    const cepFormatado = cepLimpo.length === 8
    ? cepLimpo.slice(0, -3) + '-' + cepLimpo.slice(-3)
    : cepLimpo;

    _set('Cep', cepFormatado);
    _setSelect('estadoID', end?.Cidade.EstadoID, true);
    setCidadeQuandoCarregar(form, end?.Cidade?.ID);

    // _set('Email', dados?.CorreioEletronico ?? dados?.Email);

    // telefone: se vier lista, pega o primeiro não-fax
    let tel = '';
    if (Array.isArray(dados?.Telefones) && dados.Telefones.length) {
      const t = dados.Telefones.find(x => !x.Is_fax) || dados.Telefones[0];
      tel = [t?.Ddd, t?.Numero].filter(Boolean).join('');
    }
    _set('Telefone', tel, true);
  };

  const onSucesso = (resultados) => {
    if (!resultados?.cnpj) {
      toastErroCarregar(i18next.t('ErroNaoEncontrado'));
      return;
    }
    _preencher(resultados.cnpj);
  };

  const onErroServidor = (resultadosOuMsg) => {
    console.warn(i18next.t('ErroConexao'), resultadosOuMsg?.mensagem || resultadosOuMsg);
  };

  const onErroConexao = () => {
    console.warn(i18next.t('ErroConexao'));
  };

  // --- validação local do CNPJ ---
  if (!cnpj) return;
  const cnpjLimpo = onlyAlphaNum(cnpj);
  if (!isCnpjLike(cnpjLimpo)) {
    onErroServidor({ mensagem: i18next.t('ErroInvalido') });
    toastErroCarregar(i18next.t('ErroInvalido'));
    return;
  }

  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'X-Requested-With': 'XMLHttpRequest'
  };
  const body = new URLSearchParams({ cnpj: cnpjLimpo });

  loadFullPage.mostrar();
  try {
    await postFetch(
      cnpjEndpoint,
      body,
      onSucesso,         // callbackSucesso
      onErroServidor,    // callbackErro
      onErroConexao,     // callbackErroConexao
      true,              // exibirToastErroConexao (padrão do seu validador)
      true,              // exibirToastErroServidor
      headers
    );
  } 
  finally {
    loadFullPage.esconder();
  }
}